import { registerApi as api } from '../../api';

export const fetchLeaveRegisterData = async (current_month) => {
    try {
        const client_ID = sessionStorage.getItem('selectedClient')
        const response = await api.get(`/leave_register_get/${current_month}`, {
            params: {
                client_id: client_ID
            }
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const updateLeaveRegister = async (id, LeaveData) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.put(`/leave_register_update/${id}`, LeaveData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const deleteLeaveRegister = async (id) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.delete(`/leave_register_delete/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}


export const leaveRegisterUpload = async (LeaveDataInput, targetMonth) => {
    try {
        const token = sessionStorage.getItem('token');
        const selectedClientID = sessionStorage.getItem('selectedClient')
        const params = { selectedClientID };
        if (targetMonth) params.target_month = targetMonth;
        const response = await api.post('/upload_leave_register', LeaveDataInput, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            },
            params
        });

        console.log("Leave register upload response:", response);

        return {
            data: response.data,
            status: response.status,
        };

    } catch (error) {
        console.error("Error during leave register upload:", error);
        let errorMessage = 'Something went wrong';

        if (error.response) {
            const data = error.response.data;
            if (data.error) {
                errorMessage = Array.isArray(data.error) ? data.error.join(', ') : data.error;
            } else if (data.message) {
                errorMessage = data.message;
            }
        }

        throw errorMessage;
    }
};

export const multiDeleteLeaveRegister = async (ids) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post('/delete_multipleLeave_register', ids, {
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });
        console.log(response.data);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
};
